import React from 'react';
import { Redirect } from 'react-router-dom';

// Material UI
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

// Components
import DashboardLayout from '../_layout/DashboardLayout/dashboard.layout';
import LoadingPage from '../_boilerplate/LoadingPage/loading-page.container';
import { AccordionSection } from '../../_core/_ui/accordion-section.component';
import { UpdateCompanyFormContainer } from '../../Company/UpdateCompanyForm/update-company-form.container';
import { getActiveAssessmentId } from '../../../lib/services/assessment.service';
import { getActiveCompanyId, getCompany } from '../../../lib/services/company.service';
import { hasConfigurationAccess } from '../../../lib/services/configuration.service';
import { hasAdminAccess } from '../../../lib/services/user.service';
import { AgeGroupBucketSettings } from '../../AgeGroup/AgeGroupBucketSettings/age-group-bucket-settings.component';
import { UpdateAssessmentGraphQL } from '../../Assessment/UpdateAssessment/update-assessment.graphql';
import { FormatTemplateList } from '../../FormatTemplate/FormatTemplateList/format-template-list.component';
import { IntlMsg } from '../../_core/IntlMsg/intl-msg.component';
import { messages } from './settings.messages';
import { HOME_ROUTE } from '../../../../_configuration';

export const SettingsPage = () => {
  const { hasConfiguration, loading: accessLoading } = hasConfigurationAccess();
  const { isAdmin, loading: adminLoading } = hasAdminAccess();
  const companyId = getActiveCompanyId();
  const activeAssessmentId = getActiveAssessmentId();
  const { company, loading, refetch } = getCompany(companyId);

  if (accessLoading || adminLoading) return <LoadingPage />;
  if (!hasConfiguration) return <Redirect to={HOME_ROUTE} />;

  return (
    <DashboardLayout hideSidebar>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          {/* A bucket decides which seed weights an age group scores against — platform-wide,
              so association staff never see this section. */}
          {isAdmin && (
            <AccordionSection size="large" unmountOnExit title={<IntlMsg {...messages.ageGroups} />}>
              <AgeGroupBucketSettings assessmentId={activeAssessmentId} />
            </AccordionSection>
          )}
          <AccordionSection size="large" title={<IntlMsg {...messages.assessmentSettings} />}>
            <UpdateAssessmentGraphQL />
          </AccordionSection>
          <AccordionSection size="large" title={<IntlMsg {...messages.associationSettings} />}>
            {loading && !company && <Typography><IntlMsg {...messages.loading} /></Typography>}
            {company && <UpdateCompanyFormContainer company={company} refetch={refetch} />}
          </AccordionSection>
          <AccordionSection size="large" title={<IntlMsg {...messages.formatStageTemplates} />}>
            <FormatTemplateList />
          </AccordionSection>
        </Grid>
      </Grid>
    </DashboardLayout>
  );
};

